import { useEffect, useState } from "react";
import { IBoard } from "../../../../libs/types/boards";
import {
  ISocketReturn,
  TypeSockectEvent,
} from "../../../../libs/types/sockets";
import { useLoginContext } from "../context";
import DataFunctions from "../functions/database";
import BoardsAPI from "../services/api/boards";
import { socket } from "../services/socket";

const room: TypeSockectEvent = "board_update";

const useBoardsSocket = () => {
  const [data, setData] = useState<IBoard[]>([]);
  let auth = useLoginContext();

  useEffect(() => {
    getBase();
  }, []);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on(room, (io: ISocketReturn) => {
        //console.log(room, io);

        const ioData: IBoard = io.data;
        const index = data.findIndex(
          (item) =>
            new DataFunctions().getId(item) ===
            new DataFunctions().getId(ioData)
        );

        var current_data: IBoard[] = [...data];

        switch (io.socketReturn) {
          case "add":
            current_data.push(ioData);
            break;

          case "update":
            if (index > -1) current_data[index] = ioData;
            break;

          case "delete":
            current_data = data.filter(
              (item) =>
                new DataFunctions().getId(item) !==
                new DataFunctions().getId(ioData)
            );
            break;
        }

        setData(current_data);
      });
    }
  }, [socket, data]);

  const getBase = async () => {
    if (auth.loginDataContext.master) {
      new BoardsAPI().list().then(async (res) => {
        if (res.success) await setData(res.data);
      });
    } else {
      new BoardsAPI()
        .listByUser(auth.loginDataContext.id ? auth.loginDataContext.id : "")
        .then(async (res) => {
          if (res.success) await setData(res.data);
        });
    }
  };

  return data;
};

export default useBoardsSocket;
